/**
 * This is the user creation component
 *
 * @author Preet Kaur
 * @version 1.0.0
 * @Date 4 Dec 2019
 */

import React, { useState, useMemo, useEffect } from "react";
import styled from "styled-components";
import DisplayStats from "components/Statistics/DisplayStats";
import { Toaster } from "react-hot-toast";
import SimpleButton from 'components/GlobalButtons/SimpleButton';

import { Col, Row } from 'antd';

import ADI_Input from 'components/Input';
import {
  WhiteButton as MyButton,
  Body,
  Label,
} from "../../../../statics/styles/StyledComponents";
import { PlusOutlined } from '@ant-design/icons';
import AdiTable from 'components/AdiTable'
import PurchaseKeys from "./PurchaseKeys";
import KeyList from './KeyList';
import AddGS1KeyAPI from "../apis/Gs1Key";
import { getSessionStorage } from "utilities/Functions/GlobalHelperFunctions";
import { SESSION_STORAGE_KEYS, TABLE_CELL_CONFIG } from "utilities/CONSTANTS";
import ProductPartnerAPI from "../apis/ProductPartnerAPI";
import PageBreadcrumb from "components/PageBreadcrumb";
import { useAuthStore } from "zustand-stores";
import { AuthStore } from "zustand-stores/useAuthStore";
import TableCard from "components/AdiTable/TableCard";
import ActiveKeysIcon from '../../../../assets/analytics/admin/active_keys.svg';
import InactiveKeysIcon from '../../../../assets/analytics/admin/inactive_keys.svg';
import TotalKeysIcon from '../../../../assets/analytics/admin/total_keys.svg';
import TotalProductsIcon from '../../../../assets/analytics/admin/total_products.svg';
import { Analytics } from 'components/Analytics';



type Props = {
  active: boolean;
}

export interface KeyListProps {
  getDataByCustomer: () => void;
  productSelected: any;
  onDataLoad: (data: any[]) => void;
  selectedFilter: string;
  onFilterChange: (status: string) => void;
  onKeyStatusChange: () => void;
  refreshTrigger: number;
}

const SerialisedCode = (props: Props) => {
  const isAdminModuleReadOnly = useAuthStore((state: AuthStore) => state.moduleAccess.admin.isReadOnly);
  const [productSelected, setProductSelected] = useState<any>();
  const [modals, setModals] = useState({
    open: false,
    isEdit: false,
    onClose: false,
    selectedRecord: null,
    disabled: false,
  })
  const [loading, setLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [filteredUser, setFilteredUser] = useState<any[]>([])
  const [searchText, setSearchText] = useState("");
  const [isMainView, setIsMainView] = useState(true);
  const [productsListing, setProductsListing] = useState<any[]>([]);
  const CLIENT_CODE = getSessionStorage(SESSION_STORAGE_KEYS.BIZ_CODE);
  const [selectedStatus, setSelectedStatus] = useState<string>('Total Products');
  const [filteredData, setFilteredData] = useState<any>([]);
  const [analyticsType, setAnalyticsType] = useState<'main' | 'detail'>('main');
  const [detailStats, setDetailStats] = useState<any>({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [mainSelectedStatus, setMainSelectedStatus] = useState('Total Products');
  const [detailSelectedStatus, setDetailSelectedStatus] = useState('Total Keys');
  const [forceRender, setForceRender] = useState(0);
  // The table columns for AdiTable element
  const userLicenseColumns = [
    {
      title: 'PRODUCT NAME',
      dataIndex: 'product_name',
      ...TABLE_CELL_CONFIG
    },
    {
      title: 'PRODUCT ID',
      dataIndex: 'product_id',
      ...TABLE_CELL_CONFIG,
      render: (text: any, record: any) => (
        <p style={{ textTransform: 'uppercase' }}>{record.product_id}</p>
      ),
    },
    {
      title: 'TOTAL KEYS',
      dataIndex: 'total_keys',
      ...TABLE_CELL_CONFIG,
    },
    {
      title: 'ACTIVE KEYS',
      dataIndex: 'active_keys',
      ...TABLE_CELL_CONFIG,
    },
    {
      title: 'INACTIVE KEYS',
      dataIndex: 'inactive_keys',
      ...TABLE_CELL_CONFIG,
    },
    {
      title: 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      width: 130,
      fixed: 'right',
      // render: (text: any, record: any) => (
      //   <Label onClick={() => { setIsMainView(false); setProductSelected(record) }} style={{ cursor: "pointer" }}>
      //     View
      //   </Label>
      // ),
      render: (text: any, record: any) => {

        const items = [
          {
            label: "View",
            onClick: () => {
              setIsMainView(false);
              setProductSelected(record)
            },
          },
        ];

        return <AdiTable.ActionDropdown menuItems={items} />;
      },
    }
  ]
  const onSearch = (search?: string) => {
    const text = search === undefined ? searchText.trim() : search;

    if (text && text !== "" && filteredProducts.length) {
      const userFiltered: any = filteredProducts?.filter((rec: any) => {
        return (
          rec.product_name.includes(text) || rec.product_id.includes(text)
        );
      });
      if (userFiltered.length) {
        setFilteredUser(userFiltered);
      } else {
        setFilteredUser([]);
      }
    } else {
      setFilteredUser(filteredProducts);
    }
  };

  const userModal = () => {
    setModals({ ...modals, open: true })
  }
  const closeModal = () => {
    setModals({ ...modals, open: false })
  }

  const searchUser = () => {
    onSearch();
  };
  const getDataByCustomer = async () => {
    setLoading(true)
    try {
      const response = await AddGS1KeyAPI.getKeyByCustomer()
      console.log(response, 'getKeyByCustomer response::')
      if (Array.isArray(response) && response.length > 0) {
        setFilteredProducts(response)
        setFilteredUser(response)
        setFilteredData(response);
      } else {
        if (response.body?.includes('ResourceNotFoundException')) {
          setFilteredProducts([])
          setFilteredUser([])
        }
      }
    } catch (e) {
      console.log('getKeyByCustomer error::', e)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    console.log('ok')
    getDataByCustomer()
  }, []);

  useEffect(() => {
    console.log('CLIENT_CODE==>', CLIENT_CODE)
    if (CLIENT_CODE !== 'acg') {
      getProductsList()
    }
  }, [CLIENT_CODE]);

  const getProductsList = () => {
    setLoading(true)
    ProductPartnerAPI.getAllProducts(CLIENT_CODE).then((products: any) => {
      if (Array.isArray(products) && products.length > 0) {
        // filter the products that has void as false
        const filteredProducts = products?.filter((item: any) => item.void === 'false' || item.void === false)
        setProductsListing(filteredProducts || [])
      }
    }).catch((err: any) => {
      console.log('err', err)
    }).finally(() => {
      setLoading(false)
    })
  };

  const statsData = useMemo(() => {

    const totalProduct = filteredProducts.length || 0
    const totalKeys = filteredProducts.reduce((accumulator: any, currentValue: any) => {
      return Number(accumulator) + Number(currentValue.total_keys);
    }, 0);
    const activeKeys = filteredProducts.reduce((accumulator: any, currentValue: any) => {
      return Number(accumulator) + Number(currentValue.active_keys);
    }, 0);
    return [

      {
        text: 'Total Products',
        number: totalProduct,
      },
      {
        text: 'Total Keys',
        number: totalKeys,
      },
      {
        text: 'Active Keys',
        number: activeKeys,
      },
      {
        text: 'Inactive Keys',
        number: totalKeys - activeKeys,
      },

    ]
  }, [getDataByCustomer])

  const getValueByTitle = (title: string) => {
    const item = statsData?.find((item: any) => item.text === title);
    return item ? item.number : 0;
  };

  useEffect(() => {

    if (selectedStatus) {
      if (selectedStatus === 'Total Products') {
        setFilteredData(filteredProducts);
      } else if (selectedStatus === 'Total Keys') {
        const filtered = filteredProducts.filter((product: any) => Number(product.total_keys) !== 0);
        setFilteredData(filtered);
      } else if (selectedStatus === 'Active Keys') {
        const filtered = filteredProducts.filter((product: any) => Number(product.active_keys) !== 0);
        setFilteredData(filtered);
      } else if (selectedStatus === 'Inactive Keys') {
        const filtered = filteredProducts.filter((product: any) => Number(product.inactive_keys) !== 0);
        setFilteredData(filtered);
      }
    }

  }, [selectedStatus, filteredUser]);

  const handleMainAnalyticsClick = (status: string) => {
    setMainSelectedStatus(status);
    if (status === 'Total Products') {
      setFilteredData(filteredProducts);
    }
  };

  const handleClick = (status: string) => {
    console.log('Clicking:', status);
    setDetailSelectedStatus(status);
    setForceRender(prev => prev + 1);

    switch (status) {
      case 'Total Keys':
        setFilteredData(filteredProducts);
        break;
      case 'Active Keys':
        setFilteredData(filteredProducts.filter(item => item.status?.toLowerCase() === 'active'));
        break;
      case 'Inactive Keys':
        setFilteredData(filteredProducts.filter(item => item.status?.toLowerCase() === 'inactive'));
        break;
    }
  };

  const MainAnalytics = () => {
    const items = [
      {
        icon: <img src={TotalProductsIcon} alt="AllGridIcon" />,
        title: 'Total Products',
        value: getValueByTitle('Total Products'),
        onClick: () => handleMainAnalyticsClick('Total Products'),
        isSelected: mainSelectedStatus === 'Total Products',
      }
    ];

    return <Analytics items={items} />;
  };

  const DetailAnalytics = () => {
    const items = [
      {
        icon: <img src={TotalKeysIcon} alt="AllGridIcon" />,
        title: 'Total Keys',
        value: detailStats.total || 0,
        onClick: () => handleClick('Total Keys'),
        routeTo: '',
      },
      {
        icon: <img src={ActiveKeysIcon} alt="AllGridIcon" />,
        title: 'Active Keys',
        value: detailStats.active || 0,
        onClick: () => handleClick('Active Keys'),
        routeTo: '',
      },
      {
        icon: <img src={InactiveKeysIcon} alt="AllGridIcon" />,
        title: 'Inactive Keys',
        value: detailStats.inactive || 0,
        onClick: () => handleClick('Inactive Keys'),
        routeTo: '',
      }
    ];

    return (
      <Analytics
        key={`${detailSelectedStatus}-${forceRender}`}
        items={items}
        defaultSelected={detailSelectedStatus}
      />
    );
  };

  const mainView = () => {
    return (
      <div style={{
        marginTop: '20px',
      }}>
        <TableCard>
          <Row gutter={[0, 15]} align="middle" justify="space-between" style={{ margin: '0 10px' }}>
            <Col style={{ marginLeft: "0px" }}>
              <ADI_Input
                type="search"
                placeholder="Search by Product Name"

                onSearch={() => searchUser()}
                onChange={(e: any) => {
                  const value = e.target.value
                  setSearchText(value)
                  if (!value) {
                    onSearch('')
                  }
                }}
                style={{ width: '250px' }}
                value={searchText}
                allowClear
              />
            </Col>
            {
              !isAdminModuleReadOnly &&
              <Col style={{ marginRight: "2px" }}>
                <SimpleButton
                  text={<BtnText><PlusOutlined />&nbsp;&nbsp;Purchase Key</BtnText>}
                  onClick={userModal}
                  key="create-user-button"
                  style={{ marginTop: '5px', padding: '0px 15px' }}
                />
              </Col>
            }

          </Row>
          <PurchaseKeys
            open={modals.open}
            onClose={closeModal}
            getDataByCustomer={getDataByCustomer}
            productsList={productsListing}
          />
          <AdiTable
            loading={loading}
            columns={userLicenseColumns}
            tableData={filteredData}
            fullWidth
            marginTop='20px'
          />
        </TableCard>
      </div>
    );
  }

  const goBack = () => {
    setIsMainView(true);
    setMainSelectedStatus('Total Products');
  };

  const handleViewChange = (record: any) => {
    setIsMainView(false);
    setProductSelected(record);
    setDetailSelectedStatus('Total Keys');
    setForceRender(prev => prev + 1);
  };

  const navItems = [
    {
      text: 'Back to Serialized Codes',
      onClick: () => {
        goBack();
      },
    },
    {
      text: `${productSelected?.product_name}`,
    }
  ];

  useEffect(() => {
    if (!isMainView) {
      setAnalyticsType('detail');
      handleClick('Total Keys');
    } else {
      setAnalyticsType('main');
      handleMainAnalyticsClick('Total Products');
    }
  }, [isMainView]);

  const updateDetailStats = async (keyListData: any[]) => {
    if (!Array.isArray(keyListData)) {
      console.error('Invalid data format received');
      return;
    }

    const newStats = {
      total: keyListData.length,
      active: keyListData.filter(item => item.status?.toLowerCase() === 'active').length,
      inactive: keyListData.filter(item => item.status?.toLowerCase() === 'inactive').length
    };

    setDetailStats(newStats);

    if (detailSelectedStatus === 'Total Keys') {
      setFilteredData(keyListData);
    } else if (detailSelectedStatus === 'Active Keys') {
      setFilteredData(keyListData.filter(item => item.status?.toLowerCase() === 'active'));
    } else if (detailSelectedStatus === 'Inactive Keys') {
      setFilteredData(keyListData.filter(item => item.status?.toLowerCase() === 'inactive'));
    }
  };

  const forceUpdate = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    console.log('Current selected status:', detailSelectedStatus); // Para debug
  }, [detailSelectedStatus]);

  return (
    <>
      {!isMainView && <div style={{ color: 'gray', fontSize: '13px' }}>
        <PageBreadcrumb navItems={navItems} />
      </div>}
      <Toaster />
      <div style={{ marginBottom: '20px' }}>
        {isMainView ? <MainAnalytics /> : <DetailAnalytics />}
      </div>
      {isMainView ? mainView() : (
        <KeyList
          getDataByCustomer={getDataByCustomer}
          productSelected={productSelected}
          onDataLoad={updateDetailStats}
          selectedFilter={detailSelectedStatus}
          onFilterChange={handleClick}
          onKeyStatusChange={() => {
            forceUpdate();
            getDataByCustomer();
          }}
          refreshTrigger={refreshTrigger}
        />
      )}
    </>
  );
};

const BtnText = styled.span`
  color: var(--white-text-color);
  display: flex;
  align-items: center;
`

export default SerialisedCode;
